export const ABBREVIATIONS_ARR = [
  // Needs to be sorted from largest to lowest
  { divisor: 1e6, abbreviation: 'M' },
  { divisor: 1e3, abbreviation: 'K' },
];
export const DEFAULT_DECIMAL_PLACES = 2;
export const countTransform = (
  count: number,
  locale: string,
  decimalPlaces = DEFAULT_DECIMAL_PLACES,
  abbreviationArr = ABBREVIATIONS_ARR,
): string => {
  let target: (typeof ABBREVIATIONS_ARR)[number] | undefined = undefined;

  for (const numberObj of abbreviationArr) {
    if (count < numberObj.divisor) continue;
    target = numberObj;
    break;
  }
  if (!target) {
    return Intl.NumberFormat(locale).format(count);
  }
  const { divisor, abbreviation } = target;
  const dividedNum = count / divisor,
    modulo = count % divisor;
  if (!modulo) {
    return `${Intl.NumberFormat(locale).format(dividedNum)}${abbreviation}`;
  }
  if (!decimalPlaces) {
    return `${Math.floor(dividedNum).toLocaleString(locale)}${abbreviation}`;
  }
  // The abbreviated count is rounded down to avoid over-reporting.
  const addedDecimal = new Intl.NumberFormat(locale, {
    maximumFractionDigits: decimalPlaces + 1,
  }).format(dividedNum);
  const delimiter = addedDecimal.search(/[^0-9]/);
  const reducedNumber = addedDecimal.slice(0, delimiter + decimalPlaces + 1);
  return `${reducedNumber}${abbreviation}`;
};
